import { PropsWithChildren } from 'react';
import { TextComponent, TextComponentProps } from '../ui-kit';

type FieldLabelProps = PropsWithChildren & {
  isRequired?: boolean;
  color?: string;
  level?: TextComponentProps['level'];
};

export const FieldLabel = ({
  children,
  isRequired = false,
  color = 'var(--colorError, #D20059)',
  level = 7,
}: FieldLabelProps) => {
  return (
    <TextComponent level={level} className="field-label">
      {children}
      {isRequired && (
        <TextComponent level={level} color={color}>
          *
        </TextComponent>
      )}
    </TextComponent>
  );
};
